import {
    trim,
    map
} from "./utils";

function _hmt_push(args) {
    window._hmt = window._hmt || [];
    window._hmt.push(args);
}

// /**
//  * PV跟踪
//  * @param {*} pageURL 指定要统计PV的页面URL。此项必选。
//  */
// function trackPageview(pageURL) {
//     _hmt_push(['_trackPageview', pageURL]);
// }

// /**
//  * 自定义变量追踪
//  * @param {*} index 是自定义变量所占用的位置。取值为从1到5。该项必选。
//  * @param {*} name 是自定义变量的名字。该项必选。
//  * @param {*} value 就是自定义变量的值。该项必选。
//  * @param {*} opt_scope 是自定义变量的作用范围。该项可选。1为访客级别（对该访客始终有效），2为访次级别（在当前访次内生效），3为页面级别（仅在当前页面生效）。默认为3。
//  */
// function setCustomVar(index, name, value, opt_scope) {
//     _hmt_push(['_setCustomVar', index, name, value, opt_scope]);
// }

/**
 * 事件追踪
 * @param {*} category 要监控的目标的类型名称，通常是同一组目标的名字，比如"视频"、"音乐"、"软件"、"游戏"等等。该项必填，不填、填"-"的事件会被抛弃。
 * @param {*} action 用户跟目标交互的行为，如"播放"、"暂停"、"下载"等等。该项必填，不填、填"-"的事件会被抛弃。
 * @param {*} opt_label 事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项选填，不填、填"-"代表此项为空。
 * @param {*} opt_value 事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
 */
function trackEvent(category, action, opt_label, opt_value) {
    _hmt_push(['_trackEvent', category, action, opt_label, opt_value]);
    //_console.log([category, action]);
}

const _category = location.pathname.replace(/\/$/, "").replace(/^\//, "").split("/").slice(-2).join("/");
//_console.log(_category);

// (function (WZ) {
//     WZ.on("user:do", function (actionName, evt) {
//         var el = document.getElementById(evt.targetId);
//         var opt_label = document.title;
//         var rData = '';
//         var rEid = '';
//         var rValue = '-';
//         var rType = _category;
//         if(el && el.getAttribute) {
//             rType = el.getAttribute("r-type") || _category; //要监控的目标的类型名称
//             rEid = el.getAttribute("r-eid") || '';
//             rData = el.getAttribute("r-data") || "";  // 事件数据
//             rValue = el.getAttribute("r-value") || "";  // 事件权重、时长、价值等？
//             if(rData) {
//                 opt_label += '' + rData;
//             }
//             if(rEid) {
//                 _trackEvent(rType, 'r-' +rEid, opt_label, rValue);
//             }
//         }
//         _trackEvent(rType, 'a-' + actionName, opt_label, rValue);
//     });

// })(WZ);


let hasInit = false

const Page = {
    name: "",
    path: ''
}


function pathKey(path) {
    const keys = path.replace(/^\/+/, '').replace(/\/+$/, '').split('/').slice(0, 4) // 最多只取前4级
    const maxIndex = keys.length - 1
    const key = map(keys, (key, i) => i === maxIndex ? (key.length > 5 ? key.slice(0, 2) + '_' + key.slice(-2) : key) : key.slice(0, 2)).join('-')
    return key
}

const PATH_KEY = pathKey(location.pathname)

// alert(PATH_KEY)


function classKey(target) {
    if (!target) {
        return ''
    }
    let key = ''
    const {
        className,
        parentNode
    } = target
    if (className) {
        if (/r-eid-([-\w]+)/i.test(className)) {
            key = RegExp.$1
        }
    }
    return key ? key : parentNode ? classKey(parentNode) : ''
}

function reportKey(target) {
    if (!target) {
        return null
    }
    const {
        parentNode,
        getAttribute,
        className
    } = target
    let key = getAttribute ? target.getAttribute('r-eid') : ''
    if (!key) {
        if (/r-eid-([-\w]+)/i.test(className)) {
            key = RegExp.$1
        }
    }
    return key ? key : parentNode ? reportKey(parentNode) : ''
}


function textKey(target) {
    if (!target) {
        return null
    }
    const {
        parentNode,
        textContent,
        innerText,
        tagName
    } = target

    let text = ""
    if (/^(A|BUTTON|INPUT)$/.test(tagName)) {
        text = trim((textContent || innerText || ''))

        text = text.length > 8 ? text.slice(0, 20) : tagName.slice(0, 3) + '_' + text
    }


    return text ? text : parentNode ? textKey(parentNode) : ''
}

function reportInfo(target) {
    if (!target) {
        return null
    }
    const rk = reportKey(target)
    const ck = classKey(target)
    const tk = textKey(target)
    const pre = rk ? 'R_' : ck ? 'C_' : ''

    const key = pre + (rk || ck || tk).replace(/[_-][a-z]/g, k => k.slice(1).toUpperCase())
    return {
        key,
        ck,
        rk,
        tk
    }
}

function init(opts) {
    if (hasInit) {
        return
    }
    hasInit = true
    // console.log('Stat.init()');
    opts = opts || {}

    // 路由跳转
    const router = opts.router
    if (router && router.afterEach) {
        router.afterEach((to) => {
            const path = `/award${to.path}`
            Page.path = path
            // console.log(path);
            // trackPageview(path)
        })
    }

    // 用户动作
    let supportTouch = false

    function handle(e) {
        const {
            type,
            target
        } = e
        supportTouch = supportTouch || /touch/.test(type)
        if (supportTouch && type === 'click') { // 避免重复统计
            return
        }
        // console.log(supportTouch);
        // console.log({target});
        const info = reportInfo(target)
        if (info && info.key) {
            const key = PATH_KEY + '-' + info.key
            // console.log(key)
            const title = document.title
            // console.log(JSON.stringify({type: e.type, info}));
            trackEvent(_category, key, title)
        }
    }
    document.body.addEventListener('click', handle, false)
    document.body.addEventListener('touchend', handle, false)
}

export default {
    init
}
